import React, { useState } from 'react';
import { Box, Typography, Button, Collapse, useTheme, List, ListItem, ListItemText, Grid } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import eDevletInfo from '../../assets/images/relative-join-form/e-devlet-info.webp';

const DetailedInfo: React.FC = () => {
    const [expanded, setExpanded] = useState(false);
    const theme = useTheme();

    const handleToggle = () => {
        setExpanded(!expanded);
    };

    return (
        <Box
            sx={{
                backgroundColor: '#FBEFE3',
                padding: theme.spacing(2),
                borderRadius: '4px',
                marginY: theme.spacing(2),
            }}>
            <Typography variant="body1" color="#945F2F" paddingLeft="8px" fontWeight={theme.typography.fontWeightBold} gutterBottom>
                Nüfus Kayıt Örneği Belgesi'ne nasıl ulaşırım?
            </Typography>
            <List sx={{ paddingLeft: 0 }}>
                {[1, 2, 3, 4].map(num => (
                    <ListItem key={num} sx={{ display: 'flex', alignItems: 'flex-start', padding: 0 }}>
                        <Box
                            sx={{
                                flexShrink: 0,
                                width: '2rem',
                                fontWeight: 'bold',
                                color: '#E49248',
                                fontSize: '1.2rem',
                                textAlign: 'center',
                                lineHeight: '1.7',
                            }}>
                            {num}.
                        </Box>
                        <ListItemText
                            primary={
                                <Box
                                    sx={{
                                        color: '#945F2F',
                                        marginLeft: theme.spacing(1),
                                        lineHeight: '1.5',
                                    }}>
                                    {num === 1 && (
                                        <>
                                            E-devlet'e giriş yapılarak arama bölümüne <strong>"Nüfus Kayıt Örneği Belgesi Sorgulama"</strong> yazılır
                                            ve aratılır.
                                        </>
                                    )}
                                    {num === 2 && (
                                        <>
                                            Gerekli onaylar verildikten sonra, çıkan ekranda Nüfus Kayıt Örneği Tipi <strong>"Aile"</strong>, Eski Eş
                                            Listele ve Vukuatlı Belge seçenekleri <strong>"Evet"</strong> olarak işaretlenir. Belgenin Neden
                                            Verileceği alanı için <strong>"Kişi Talebi"</strong> seçilir. <strong>"Sorgula"</strong> butonuna basılır.
                                        </>
                                    )}
                                    {num === 3 && (
                                        <>
                                            Sağ üstte yer alan <strong>"Dosyayı İndir"</strong> butonuna tıklanarak nüfus kayıt örneği belgesi cihaza
                                            indirilir.
                                        </>
                                    )}
                                    {num === 4 && (
                                        <>
                                            KoçAilem aile davet formuna geri dönülerek yukarıda belirtilen alana cihaza indirilmiş olan{' '}
                                            <strong>PDF belgesi</strong> yüklenir.
                                        </>
                                    )}
                                </Box>
                            }
                        />
                    </ListItem>
                ))}
                <Button
                    disableRipple
                    onClick={handleToggle}
                    sx={{
                        marginTop: theme.spacing(1),
                        color: theme.palette.primary.main, // Match text color
                        textTransform: 'none',
                        fontWeight: 'bold', // Make text bold
                        '&:hover': {
                            backgroundColor: 'transparent', // Remove hover effect
                        },
                        '&:focus': {
                            outline: 'none', // Remove focus outline
                        },
                        display: 'flex',
                        alignItems: 'center',
                    }}
                    endIcon={expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}>
                    Detaylı Bilgi
                </Button>
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <ListItem>
                        <ListItemText
                            sx={{ color: '#945F2F' }}
                            primary={
                                <>
                                    <strong>Aile Kayıt Örneği</strong>, kendisi, Eşi, Çocukları ve varsa Eski Eş/Eşlerine (isteğe bağlı) ait bilgileri
                                    içeren kayıtlardan oluşmaktadır.
                                </>
                            }
                        />
                    </ListItem>
                    <Grid container justifyContent="center" sx={{ marginTop: theme.spacing(2) }}>
                        <img src={eDevletInfo} alt="Example usage" style={{ maxWidth: '100%', borderRadius: theme.shape.borderRadius }} />
                    </Grid>
                </Collapse>
            </List>
        </Box>
    );
};

export default DetailedInfo;
